/**
 * The per-referral "Indlæs kvittering" field on the Udbakke cards is a
 * technical fallback (receipts are matched automatically in Communicate,
 * MedCom REF01 2.6). Only admins see it: platform admins and clinic
 * administrators (clinic_admin / main_clinic_admin), the same check other
 * admin-only clinic UI uses (`isPlatformAdmin || isClinicAdmin(clinicId)`).
 */
export function canImportReceiptManually(input: {
  isPlatformAdmin: boolean;
  isClinicAdmin: boolean;
}): boolean {
  return input.isPlatformAdmin || input.isClinicAdmin;
}
